<div class="form-check me-2" *ngIf="allSelectable">
  <input type="checkbox" class="form-check-input" [checked]="isAllChecked()" (change)="selectAll()" />
  <label class="form-check-label">Select All</label>
</div>
<div class="form-check me-2" *ngFor="let option of options" [ngClass]="{'form-check-inline': inline}">
  <input type="checkbox" class="form-check-input" [checked]="isChecked(getValue(option))"
    (change)="toggleCheck(getValue(option))" [disabled]="disabled ? disabled : isDisabled(getValue(option))" />
  <label class="form-check-label">{{getLabel(option)}}</label>
</div>
